import { render } from "./PreviewModal.vue?vue&type=template&id=124b86ef&scoped=true"
import script from "./PreviewModal.vue?vue&type=script&lang=js"
export * from "./PreviewModal.vue?vue&type=script&lang=js"

import "./PreviewModal.vue?vue&type=style&index=0&id=124b86ef&scoped=true&lang=css"
import "./PreviewModal.vue?vue&type=style&index=1&id=124b86ef&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-124b86ef"

export default script